import { AppBar, Button, Checkbox, createMuiTheme, FormControl, FormControlLabel, FormLabel, IconButton, MenuItem, MuiThemeProvider, Paper, Select, Slide, Tab, Tabs, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Search from '@material-ui/icons/Search';
import { format, isAfter, subMonths } from 'date-fns';
import { inject, observer } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { withLoading } from '../../contexts/LoadingContext';
import ExtratoCoparticipacaoService from '../../services/ExtratoCoparticipacaoService';
import FilterBeneficiario from '../share/FilterBeneficiario';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import NadaEncontrado from '../share/NadaEncontrado';

function TabContainer (props) {
  return (
    <Typography component='div' style={{ padding: 8 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired
};

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '4px'
        },
      },
    }
  });

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
    display: 'block',
    height: 120,
    maxHeight: 120
  },
  divCampos: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end'
  },
  content: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  selectData: {
    width: 250,
  },
  filterBeneficiario: {
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  marginLeft: {
    marginLeft: theme.spacing.unit,
  },
});

@inject('aplicacaoStore')
@observer
class DividasEmAbertoDetalhado extends React.Component {
  extratoService = new ExtratoCoparticipacaoService();
  state = {
    datasDeReferencia: [],
    mesAno: format(new Date(), 'MM/YYYY'),
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    fetching: false,
    beneficiarios: [],
    extrato: [],
    incluirDependentes: true,
    index: 0,
  }
  getListaDatasReferencia () {
    let dataInicial = new Date(2013, 12, 1);
    let dataAtual = new Date();
    let resultado = [];
    while (isAfter(dataAtual, dataInicial)) {
      let registro = format(new Date(dataAtual), 'MM/YYYY');
      resultado.push(registro);
      dataAtual = subMonths(dataAtual, 1);
    }
    this.setState({datasDeReferencia: resultado});
  }

  componentDidMount = async () => {
    this.setState({fetching: true});
    this.props.showLoading('...');
    this.getListaDatasReferencia();
    await this.consultarBeneficiarios();
    this.props.hideLoading();
    this.setState({fetching: false});
  }

  consultarBeneficiarios = async () => {
    const beneficiarios = await this.props.aplicacaoStore.getBeneficiarios();
    this.setState({beneficiarios: beneficiarios});
  }

  consultarExtratoDivida = async () => {
    const {carteiraSelected, mesAno, incluirDependentes} = this.state;
    const ano = Number(mesAno.substring(3, 7));
    const mes = Number(mesAno.substring(0, 2));

    this.setState({extrato: []});
    this.props.showLoading('Consultando dívidas..');
    const extrato = await this.extratoService.consultarExtratoDividaCompleto({carteira: carteiraSelected, ano, mes, incluirDependentes});
    this.setState({extrato: extrato});
    this.props.hideLoading();
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    this.consultarExtratoDivida();
  };

  handleSelectBeneficiario = (carteira, nome) => {
    if (!this._isTitular(carteira)) {
      this.setState({incluirDependentes: false});
    }
    this.setState({carteiraSelected: carteira, nomeBeneficiarioSelected: nome});
  }

  handleChangeDate = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleChangeIncluirDependentes = event => {
    this.setState({ incluirDependentes: !this.state.incluirDependentes });
  }

  handleClickLimpar = () => {
    this.setState({extrato: [], carteiraSelected: '', nomeBeneficiarioSelected: '', incluirDependentes: true, index: 0});
  }

  _isTitular = (carteira) => {
    let re = new RegExp('-00$', 'i');
    return re.test(carteira);
  }

  handleChange = (event, value) => {
    this.setState({ index: value });
  }

  handleChangeIndex = index => {
    this.setState({ index });
  }

  nf = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  df = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    month: 'long'
  });
  handleChangeSelect = event => {
    this.setState({ [event.target.name]: event.target.value });
  }

  render () {
    const { classes } = this.props;
    const { mesAno, datasDeReferencia, fetching, extrato, index } = this.state;

    const columns = [
      { name: 'Mês/Ano da Dívida' },
      {
        name: 'Data Lanc. Dívida',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography>{value === '31/12/1969' ? '-' : value}</Typography>;
          },
        }
      },

      { name: 'Matrícula' },
      { name: 'Beneficiário' },
      { name: 'Procedimento' },
      { name: 'Prestador' },
      {
        name: 'Valor Dívida',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography variant='overline'>{nf.format(value)}</Typography>;
          },
        },
      }];

    const options = {
      selectableRows: false,
      viewColumns: false,
      search: true,
      print: true,
      download: true,
      filter: false,
      responsive: 'standard',
      rowsPerPageOptions: [100, 500, 1000, 5000],
      rowsPerPage: 100,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        }
      }
    };

    let resultado = null;
    if (extrato) {
      let beneficiarios = Array.from(new Set(extrato.map(e => e.carteira))).map(
        carteira => {
          return {
            carteira: carteira,
            nome: extrato.find(e => e.carteira === carteira).nome
          };
        }
      );

      let dividasTodos = [];

      if (beneficiarios.length > 1) {
        beneficiarios = [{carteira: '', nome: 'Todos'}, ...beneficiarios];

        extrato.map(e => {
          dividasTodos.push([`${e.mes}/${e.ano}`, format(new Date(e.dataLancDivida), 'DD/MM/YYYY'), e.carteira, e.nome, e.procedimento, e.prestador, e.valDivida]);
        });
      }

      let dividasPorBenef = [];

      beneficiarios.map(
        (beneficiario) => {
          dividasPorBenef.push(extrato.filter(e => e.carteira === beneficiario.carteira).map(e => [`${e.mes}/${e.ano}`, format(new Date(e.dataLancDivida), 'DD/MM/YYYY'), e.carteira, e.nome, e.procedimento, e.prestador, e.valDivida]));
        }
      );
      resultado =
        <div>
          <AppBar position='static'>
            <Tabs
              value={index}
              onChange={this.handleChange}
              variant='scrollable'
              scrollButtons='on'>
              {beneficiarios.map((beneficiario, idx) =>
                <Tab key={idx} label={<span style={{ whiteSpace: 'pre-line' }}>{beneficiario.nome.split(' ')[0] + '\n' + beneficiario.carteira}</span>} />
              )}
            </Tabs>
          </AppBar>
          <TabContainer>
            {this.state.index === 0 && dividasTodos.length > 0
              ? <MuiThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  title={`Dívidas do beneficiário ${this.state.nomeBeneficiarioSelected}, matrícula ${this.state.carteiraSelected}, e seus dependentes, em ${this.state.mesAno}. Total dívida = ${this.nf.format(dividasTodos.map(m => m[6]).reduce((total, valDivida) => total + valDivida, 0))}`}
                  data={dividasTodos}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
              : dividasPorBenef.length > 0 && <MuiThemeProvider theme={getMuiTheme()}>
                <MUIDataTable
                  title={`Dívidas do beneficiário ${beneficiarios[this.state.index].nome}, matrícula ${beneficiarios[this.state.index].carteira}, em ${this.state.mesAno}. Total dívida = ${this.nf.format(dividasPorBenef[this.state.index].map(m => m[6]).reduce((total, valDivida) => total + valDivida, 0))}`}
                  data={dividasPorBenef[this.state.index]}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            }
          </TabContainer>
        </div>;
    }

    return (
      <React.Fragment>
        <Link to='/relatorio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Relatório de Dívidas em Aberto - Detalhado</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.root} elevation={1}>
          <div className={classes.divCampos}>
            <FormControl component='filedset' className={classes.marginLeft}>
              <FormLabel component='legend'>Mês de Referência</FormLabel>
              <Select
                value={mesAno}
                label={'Mês de Referência'}
                onChange={this.handleChangeSelect}
                inputProps={{
                  name: 'mesAno',
                }}
              >
                {datasDeReferencia.map(anoRef => {
                  return (<MenuItem key={anoRef} value={anoRef}>{anoRef}</MenuItem>);
                })}
              </Select>
            </FormControl>
            {this.state.beneficiarios && this.state.beneficiarios.length !== 0 &&
            <FormControl component='filedset' className={classes.marginLeft}>
              <FilterBeneficiario
                beneficiarios={this.state.beneficiarios}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} />
            </FormControl>}
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.incluirDependentes}
                  onChange={this.handleChangeIncluirDependentes}
                  name='incluirDependentes'
                  disabled={!this._isTitular(this.state.carteiraSelected)}
                />
              }
              label='Incluir dependentes?'
            />
            <Button
              disabled={this.state.carteiraSelected === ''}
              variant='extendedFab'
              aria-label='Consultar'
              type='submit'
              onTouchStart={this.handleSubmit}
              onClick={this.handleSubmit}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Gerar
            </Button>
          </div>
        </Paper>
        <Paper className={classes.content}>

          {extrato && extrato.length > 0
            ? resultado
            : <NadaEncontrado />}
        </Paper>
      </React.Fragment>
    );
  }
}

export default withLoading(withStyles(styles)(DividasEmAbertoDetalhado));
